import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface PromoCodeRequest extends Partial<AxiosRequestConfig> {
  params: {
    code: string
    propertyId: string
    prequoteid?: string | null
    bookingnumber?: string | null
    isSplited?: boolean
  }
}

export interface PromoCodeResponseData {
  currency?: string
  description?: string
  effectiveFrom?: string
  effectiveTo?: string
  isPercent: boolean
  promoCode: string
  promoCodeId: number
  userId?: number | null
  value: number
}

export interface PromoCodeResponse extends AxiosResponse {
  data: PromoCodeResponseData
}

export function promoCodeApi(
  {
    params,
    method = "get",
    url = `/promo/code/${params.code}/user?`,
    ...config
  }: PromoCodeRequest,
  axiosInstance: AxiosInstance,
): Promise<PromoCodeResponse> {
  let promoUrl = url
  if (params.propertyId) {
    promoUrl = promoUrl + `propId=${params.propertyId}&`
  }
  if (params.prequoteid) {
    promoUrl = promoUrl + `prequoteId=${params.prequoteid}&`
  }
  if (params.bookingnumber) {
    promoUrl = promoUrl + `bookingNumber=${params.bookingnumber}&`
  }
  promoUrl = promoUrl + `isSplited=${params.isSplited ? "true" : "false"}`
  return axiosInstance({
    method,
    url: promoUrl,
    ...config,
  }) as Promise<PromoCodeResponse>
}
// -----------------------------------------------------------

interface RefundableResponseData extends ResponseData {
  AdditionalFeeAmountPercentage: number
  AffirmFeePercentage: number
  refundProtectPremiumRate: string
  CFAR: string
  TI: string
  cfar_days: string
}

export interface RefundableResponse extends AxiosResponse {
  data: RefundableResponseData
}

export function refundableApi(
  axiosInstance: AxiosInstance,
): Promise<RefundableResponse> {
  return axiosInstance({
    method: "get",
    url: `/booking/refundprotectpremiumRate`,
  }) as Promise<RefundableResponse>
}
// -----------------------------------------------------------

export interface CancelPromoCodeRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
  }
}

export interface CancelPromoCodeResponse extends Partial<AxiosRequestConfig> {
  data: {
    bookingNo: string
    message: string
    status: number
  }
}

export function cancelPromoCodeApi(
  { params }: CancelPromoCodeRequest,
  axiosInstance: AxiosInstance,
): Promise<CancelPromoCodeResponse> {
  const url = `/booking/cancel-promocode`
  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<CancelPromoCodeResponse>
}

export interface SaveCampaignRequest extends Partial<AxiosRequestConfig> {
  params: {
    campaignData: { [key: string]: string | undefined }
  }
}

export interface SaveCampaignResponse extends AxiosResponse {
  data: string
}

export function saveCampaignApi(
  { params }: SaveCampaignRequest,
  axiosInstance: AxiosInstance,
): Promise<SaveCampaignResponse> {
  const url = `/promo/code/user/campaign`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<SaveCampaignResponse>
}
